module.exports = __webpack_public_path__ + "img/NO837886252.0656d9c6.png";